module.exports = "mutation DeleteEquipmentAnswers{\n  DeleteEquipmentAnswers(answersId: \"$answersId\") {\n    result\n  }\n}\n"